import { CardPlugin, DashboardPlugin, GridPlugin } from '@leverege/ui-dashboard';
import DataViewerCardPlugin from "./DataViewerCardPlugin.js";
import DashboardDataViewer from "./DashboardDataViewer.js";
import { ConditionEditor, DateTimeRangeEditor } from "./optionEditors/index.js";
import { ToggleEditingAction } from "./actions/index.js";
import OrderEditor from "./optionEditors/OrderEditor.js";
import ExpandedCardWrapper from "./ExpandedCardWrapper.js";
const install = molten => {
  molten.addPlugin('DataViewer', DashboardDataViewer);

  // General Dashboard Card setup
  molten.addPlugin('DashboardItem', {
    ...CardPlugin,
    viewer: ExpandedCardWrapper
  });
  molten.addPlugin('DashboardItem', DashboardPlugin);
  molten.addPlugin('DashboardItem', GridPlugin);

  // Add Option editor
  molten.addPlugin('DashboardOptionEditor', {
    type: OrderEditor.TYPE,
    editor: OrderEditor
  });
  molten.addPlugin('DashboardOptionEditor', {
    type: ConditionEditor.TYPE,
    editor: ConditionEditor
  });
  molten.addPlugin('DashboardOptionEditor', {
    type: DateTimeRangeEditor.TYPE,
    editor: DateTimeRangeEditor
  });

  // Add DataViewer wrapper
  molten.addPlugin('DashboardItem', new DataViewerCardPlugin());

  // Actions
  molten.addPlugin('Action', ToggleEditingAction);
};
export default {
  install
};